export enum TranscriptionState {
  None = 'None',
  Pending = 'Pending',
  Processing = 'Processing',
  Completed = 'Completed',
  Error = 'Error',
}

/** Mirrors the API's TranscriptInfoDto carried on the Episode DTO. */
export interface TranscriptInfo {
  id: string;
  language: string;
  isOriginal: boolean;
  fileId: string | null;
  state: TranscriptionState;
  errorMessage?: string | null;
  /** Storage URL to the .s2t JSON. Present on anonymous plugin DTOs (iframe/coyo); absent on the authenticated detail DTO, which uses getTranscriptMeta instead. */
  url?: string | null;
}

/** Raw S2T JSON shape (loaded directly from cloud storage). */
export interface S2TWord {
  word: string;
  time: number;      // ms
  duration: number;  // ms
  confidence: number;
}

export interface S2TText {
  speaker: string;
  words: S2TWord[];
}

export interface S2TSpeaker {
  name: string;
}

export interface S2THead {
  duration: number; // ms
  language: string;
}

export interface S2T {
  version: string;
  head: S2THead;
  speakers: S2TSpeaker[];
  text: S2TText[];
}

/** A single highlightable line derived from one S2TText utterance. */
export interface TranscriptCue {
  speaker: string;
  text: string;
  startMs: number;
  endMs: number;
}
